
import "stylesheets/application.scss";
const images = require.context('../images', true);

import kreawi_quiz_client from "../elm/kreawi_quiz_client/src/KreawiQuizClient";
global.kreawi_quiz_client = kreawi_quiz_client

global.kreawi_quiz_client_extras = require("../src/kreawi-quiz-client-extras.js");
